class CollectionToggles extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleModelTrigger = this.handleModelTrigger.bind(this)
    this.handleLayoutTrigger = this.handleLayoutTrigger.bind(this)

    this.els.modeltrigger?.elements.forEach(modeltriggerEl => {
      this.listeners.add(modeltriggerEl, `click`, this.handleModelTrigger)
    })

    this.els.layouttrigger.elements.forEach(layouttriggerEl => {
      this.listeners.add(layouttriggerEl, `click`, this.handleLayoutTrigger)
    })
  }

  handleModelTrigger (event) {
    const triggerEl = event.target.closest(this.els?.modeltrigger?.selector)
    const newCardStyle =
      triggerEl.dataset.style === 'standard' ? 'model' : 'standard'

    this.setCartAttribute('current_card_style', newCardStyle)

    this.els.modeltrigger.elements.forEach(modeltriggerEl => {
      modeltriggerEl.setAttribute('data-style', newCardStyle)
      modeltriggerEl.setAttribute('aria-pressed', newCardStyle === 'model')
    })

    this.externalEls.grid.element.classList.toggle(
      'clc-ProductGrid-modelCard',
      newCardStyle === 'model',
    )
  }

  handleLayoutTrigger (event) {
    const triggerEl = event.target.closest(this.els?.layouttrigger?.selector)
    const newGridLayout = triggerEl.dataset.layout
    const newGridScreen = triggerEl.dataset.screen

    this.setCartAttribute(`current_grid_layout_${newGridScreen}`, newGridLayout)
    this.pushToDataLayer(`current_grid_layout_${newGridScreen}`, newGridLayout)

    this.els.layouttrigger.elements.forEach(layouttriggerEl => {
      if (layouttriggerEl.dataset.screen === newGridScreen) {
        layouttriggerEl.setAttribute(
          'aria-pressed',
          newGridLayout === layouttriggerEl.dataset.layout,
        )
      }
    })

    if (newGridScreen === 'tablet') {
      this.externalEls.grid.element.classList.toggle(
        'clc-ProductGrid-oneTablet',
        newGridLayout === 'one',
      )
      this.externalEls.grid.element.classList.toggle(
        'clc-ProductGrid-twoTablet',
        newGridLayout === 'two',
      )
      this.externalEls.grid.element.classList.toggle(
        'clc-ProductGrid-threeTablet',
        newGridLayout === 'three',
      )
    } else {
      this.externalEls.grid.element.classList.toggle(
        'clc-ProductGrid-threeDesktop',
        newGridLayout === 'three',
      )
      this.externalEls.grid.element.classList.toggle(
        'clc-ProductGrid-fourDesktop',
        newGridLayout === 'four',
      )
    }
  }

  pushToDataLayer (attributeKey, attributeValue) {
    const viewport = attributeKey.includes('tablet')
      ? attributeKey.replace('tablet', 'mobile-tablet')
      : attributeKey

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'plp_grid_view',
      target_value: `${viewport}:${attributeValue}`,
    })
  }

  setCartAttribute (attributeKey, attributeValue) {
    // eslint-disable-next-line compat/compat
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [attributeKey]: attributeValue,
        },
      }),
    })
  }
}

if (!customElements.get('collection-toggles')) {
  customElements.define('collection-toggles', CollectionToggles)
}
